module.exports = __webpack_public_path__ + "img/fite.108d9eb7.png";